var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fa-icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.top.html",value:(_vm.ratingTooltip),expression:"ratingTooltip",modifiers:{"top":true,"html":true}}],class:_vm.currentRating.class,attrs:{"icon":_vm.currentRating.icon}})}
var staticRenderFns = []

export { render, staticRenderFns }